import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { bindActionCreators } from "redux";
import { defaultHorseExtraInfo, FileSrc, HorseExtraInfo, PrizeEarnings, SportResult } from "../../AssetContext";
import { actionCreators } from "../../state";
import LabelAndInput from "../LabelAndInput";
import { TitleColor1 } from "../typography/Typogtaphy";
import HTMLVisualizer from "../utils/HTMLVisualizer";
import { OptimizedImage, SortedImages, sortImages } from "../../functions/images";
import { sanitizeInputField } from "../../utils"
import ExtraInfoFormContainer from "./utils/ExtraInfoFormContainer";
import ExtraInfoFileUpload, { UploadUtils } from "./utils/ExtraInfoFileUpload";

export default function ExtraInfoEquestrianForm(props: {
    assetInfo: any, setUpdateFun: any, media: any, uploadUtils: UploadUtils
}): JSX.Element {

    const dispatch = useDispatch()
    const actions = bindActionCreators(actionCreators, dispatch)

    // Asset ExtraInfo fields
    const [assetName, setAssetName] = useState<string>("")
    const [horseName, setHorseName] = useState<string>("")
    const [horseAge, setHorseAge] = useState<string>("")
    const [horseSire, setHorseSire] = useState<string>("")
    const [horseColor, setHorseColor] = useState<string>("")
    const [horseRider, setHorseRider] = useState<string>("")
    const [horseGender, setHorseGender] = useState<string>("")
    const [horseMadame, setHorseMadame] = useState<string>("")
    const [horseBreeder, setHorseBreeder] = useState<string>("")
    const [horseEstValue, setHorseEstValue] = useState<string>("")
    const [horseDiscipline, setHorseDiscipline] = useState<string>("")
    const [horseFeiNumber, setHorseFeiNumber] = useState<string>("")
    const [horseBestResult, setHorseBestResult] = useState<string>("")
    const [horseDescr, setHorseDescr] = useState<string>("")
    const [horseDateOfBirth, setHorseDateOfBirth] = useState<string>("")
    const [horseTotalWinning, setHorseTotalWinning] = useState<string>("")
    const [horseRatingScuderia, setHorseRatingScuderia] = useState<string>("")

    const [sportResults, setSportResults] = useState<SportResult[]>([])
    const [prizeEarnings, setPrizeEarnings] = useState<PrizeEarnings[]>([])
    const [images2, setImages2] = useState<FileSrc[]>([])
    const [documents, setDocuments] = useState<FileSrc[]>([])
    const [coownership, setCoownership] = useState<FileSrc[]>([])
    const [prospectus, setProspectus] = useState<FileSrc[]>([])

    const [isApprovedAndTokenized, setIsApprovedAndTokenized] = useState<boolean>(false)
    const [isSubmitted, setIsSubmitted] = useState<boolean>(false)

    var newEquestrianInfo: HorseExtraInfo = {
        age: parseInt(horseAge),
        name: sanitizeInputField(horseName),
        sire: sanitizeInputField(horseSire),
        color: sanitizeInputField(horseColor),
        rider: sanitizeInputField(horseRider),
        gender: sanitizeInputField(horseGender),
        madame: sanitizeInputField(horseMadame),
        breeder: sanitizeInputField(horseBreeder),
        est_value: sanitizeInputField(horseEstValue),
        discipline: sanitizeInputField(horseDiscipline),
        fei_number: sanitizeInputField(horseFeiNumber),
        best_result: sanitizeInputField(horseBestResult),
        description: horseDescr,
        date_of_birth: parseInt(horseDateOfBirth),
        sport_results: sportResults,
        total_winning: sanitizeInputField(horseTotalWinning),
        prize_earnings: prizeEarnings,
        rating_scuderia: sanitizeInputField(horseRatingScuderia)
    }

    useEffect(() => {
        if (props.assetInfo.payload && props.assetInfo.payload.extra_info) {
            let horse1 = defaultHorseExtraInfo
            if (props.assetInfo.payload.extra_info.equestrian) {
                horse1 = props.assetInfo.payload.extra_info.equestrian.sub_assets ?
                    props.assetInfo.payload.extra_info.equestrian.sub_assets[0] :
                    defaultHorseExtraInfo
            }
            if (props.assetInfo.payload.asset_status_name !== "In Process" && props.assetInfo.payload.asset_status_name !== "Rejected")
                setIsApprovedAndTokenized(true)
            if (props.assetInfo.payload.asset_status_name === "Submitted")
                setIsSubmitted(true)

            setAssetName(props.assetInfo.payload.name)
            if (horse1) {
                setHorseName(horse1.name)
                setHorseAge(horse1.age.toString())
                setHorseSire(horse1.sire)
                setHorseColor(horse1.color)
                setHorseRider(horse1.rider)
                setHorseGender(horse1.gender)
                setHorseMadame(horse1.madame)
                setHorseBreeder(horse1.breeder)
                setHorseEstValue(horse1.est_value)
                setHorseDiscipline(horse1.discipline)
                setHorseFeiNumber(horse1.fei_number)
                setHorseBestResult(horse1.best_result)
                setHorseDescr(horse1.description)
                setHorseDateOfBirth(horse1.date_of_birth.toString())
                setHorseTotalWinning(horse1.total_winning)
                setHorseRatingScuderia(horse1.rating_scuderia)
                setSportResults(horse1.sport_results)
                setPrizeEarnings(horse1.prize_earnings)
            }
        }
    }, [props.assetInfo, props.assetInfo.loading])

    function updateEI() {
        var subAsset: any[] = []

        let tmp: SportResult[] = []
        tmp = newEquestrianInfo.sport_results.filter((el: SportResult) => el.rank !== "" && el.year !== 0 && el.rider !== "" && el.height !== "" && el.competition !== "")
        newEquestrianInfo.sport_results = tmp

        let tmp2: PrizeEarnings[] = []
        tmp2 = newEquestrianInfo.prize_earnings.filter((el: PrizeEarnings) => el.year !== 0 && el.prize !== "")
        newEquestrianInfo.prize_earnings = tmp2

        subAsset.push(newEquestrianInfo)
        const assetExtraInfo = {
            equestrian: {
                sub_assets: subAsset
            }
        }
        return assetExtraInfo
    }

    useEffect(() => {
        props.setUpdateFun(updateEI)
    }, [assetName, horseName, horseAge, horseSire, horseColor, horseRider, horseGender, horseMadame,
        horseBreeder, horseEstValue, horseDiscipline, horseFeiNumber, horseBestResult, horseDescr,
        horseDateOfBirth, horseTotalWinning, horseRatingScuderia, sportResults, prizeEarnings])

    return <>
        <ExtraInfoFormContainer>
            <div className="col-span-12 text-lg"><TitleColor1>/ Horse Information</TitleColor1></div>
            <LabelAndInput id={"assetName"} label={"Asset Name"} value={assetName} fun={setAssetName} type={"disabled"} className={"col-span-6"} required={true} />
            <LabelAndInput id={"description"} label={"Description * (text or HTML)"} value={horseDescr} fun={setHorseDescr} type={isApprovedAndTokenized ? "disabled" : "textarea"} rows={3} className="col-span-12" required={true} />
            <HTMLVisualizer text={horseDescr} className="w-full col-span-12 text-tertiary mb-5" />

            <ExtraInfoFileUpload assetName={assetName} isSubmitted={isSubmitted}
                coownership={coownership} setCoownership={setCoownership}
                prospectus={prospectus} setProspectus={setProspectus}
                images2={images2} setImages2={setImages2}
                documents={documents} setDocuments={setDocuments}
                uploadUtils={props.uploadUtils} media={props.media} />
        </ExtraInfoFormContainer>
    </>
}